import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs/Subscription'
import { FormControl } from '@angular/forms'
import { fuseAnimations } from '../../../core/animations'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/debounceTime'
import { AdministrationService } from '../../services/administration.service'
import { dutch } from './i18n/nl'
import { english } from './i18n/en'
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service'
import { AdministrationResponse } from '../../models/administration-response'

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss'],
  animations: fuseAnimations,
})
export class AdministrationComponent implements OnInit, OnDestroy {
  searchInput: FormControl
  administrationResponse: AdministrationResponse
  onSearchChanged: Subscription
  loading = false
  administrationId: number = undefined
  totalAdministrations = 0

  constructor(
    private administrationService: AdministrationService,
    private translationLoader: FuseTranslationLoaderService,
    private route: ActivatedRoute,
  ) {
    this.translationLoader.loadTranslations(english, dutch)
    this.searchInput = new FormControl(this.administrationService.getSearch())
    this.administrationId = this.route.snapshot.params['administrationId']
  }

  ngOnInit() {
    this.onSearchChanged = this.searchInput.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .do(searchText => {
        this.administrationService.changeSearch(searchText)
      })
      .switchMap(() => {
        return this.administrationService.browse()
      })
      .subscribe((administrationResponse: AdministrationResponse) => {
        this.totalAdministrations = administrationResponse.pagination.total_results
        this.administrationService.onAdministrationsChanged.next(administrationResponse)
      })

    this.administrationResponse = this.route.snapshot.data.administrationResponse

    this.totalAdministrations = this.administrationResponse.pagination.total_results
  }

  ngOnDestroy() {
    this.onSearchChanged.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration.component.ts